var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.show
    ? _c(
        "div",
        { class: _vm.slideInClass },
        [
          !_vm.loading && _vm.hasMessages
            ? _c("nav", [
                _c(
                  "div",
                  { staticClass: "select-container" },
                  [
                    _c("Select", {
                      attrs: { options: _vm.groupedMessagesOptions },
                      model: {
                        value: _vm.activeGroup,
                        callback: function($$v) {
                          _vm.activeGroup = $$v
                        },
                        expression: "activeGroup"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "ul",
                  _vm._l(_vm.groupedMessages, function(group) {
                    return _c(
                      "li",
                      {
                        key: group.id,
                        class: {
                          active:
                            _vm.activeGroup && _vm.activeGroup.id === group.id
                        }
                      },
                      [
                        _c(
                          "a",
                          {
                            attrs: { href: "#" },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.setActiveGroup(group)
                              }
                            }
                          },
                          [
                            _c("span", { staticClass: "label" }, [
                              _vm._v(_vm._s(_vm.getGroupLabel(group)))
                            ]),
                            _vm._v(" "),
                            _vm.getGroupSubLabel(group)
                              ? _c("span", { staticClass: "sublabel" }, [
                                  _vm._v(_vm._s(_vm.getGroupSubLabel(group)))
                                ])
                              : _vm._e()
                          ]
                        )
                      ]
                    )
                  }),
                  0
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "edit-area" }, [
            _c("header", [
              _c("div", { staticClass: "title-container" }, [
                _c("div", [
                  _vm.activeGroup
                    ? _c("h1", {
                        domProps: {
                          innerHTML: _vm._s(_vm.getTitle(_vm.activeGroup))
                        }
                      })
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "close-container" }, [
                  _c(
                    "a",
                    {
                      attrs: { href: "#" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.closeFan.apply(null, arguments)
                        }
                      }
                    },
                    [_c("Icon", { attrs: { icon: "close" } })],
                    1
                  )
                ])
              ]),
              _vm._v(" "),
              _vm.activeGroup
                ? _c("div", { staticClass: "sub-title-container" }, [
                    _c("div", { staticClass: "job-profile-title" }, [
                      _vm._v(_vm._s(_vm.latestMessage.jobProfile.info))
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "job-profile-infos" }, [
                      _c("div", { staticClass: "job-profile-info" }, [
                        _c("span", [_vm._v("Ort")]),
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.latestMessage.jobProfile.placesOfWork.join(
                                ", "
                              )
                            ) +
                            "\n\t\t\t\t\t"
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            { name: "b-tooltip", rawName: "v-b-tooltip" }
                          ],
                          staticClass: "job-profile-info",
                          attrs: { title: _vm.industrialSectors }
                        },
                        [
                          _c("span", [_vm._v("Branchen")]),
                          _vm._v(
                            " " +
                              _vm._s(_vm.maxLength(_vm.industrialSectors, 20)) +
                              "\n\t\t\t\t\t"
                          )
                        ]
                      )
                    ])
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c(
              "main",
              {
                ref: "main",
                class: ["scrollbar-check", { "bg-lightest-blue": !_vm.loading }]
              },
              [
                _vm.loading
                  ? _c("Loading")
                  : [
                      _vm.hasMessages
                        ? [
                            _c(
                              "div",
                              [
                                _vm.loading
                                  ? _c("Loading")
                                  : _vm.initiator
                                  ? _c(
                                      "div",
                                      { staticClass: "message-list" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "message-list--items"
                                          },
                                          [
                                            _vm._l(_vm.messages, function(
                                              message
                                            ) {
                                              return [
                                                _vm.isShowRequestedVitaInfo(
                                                  message
                                                )
                                                  ? _c("RequestedVitaInfo", {
                                                      attrs: {
                                                        message: message
                                                      }
                                                    })
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _c("ListItem", {
                                                  key: message.id,
                                                  attrs: {
                                                    message: message,
                                                    "is-recipient": _vm.isRecipient(
                                                      message
                                                    ),
                                                    "is-latest-message": _vm.isLatestMessage(
                                                      message
                                                    ),
                                                    initiator: _vm.initiator
                                                  },
                                                  on: {
                                                    possibleChange:
                                                      _vm.loadMessages,
                                                    clickedMoreInfos:
                                                      _vm.clickedMoreInfos,
                                                    editAccessLink: function(
                                                      $event
                                                    ) {
                                                      _vm.sendAccessLink = true
                                                    }
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _vm.isShowCustomerData(message)
                                                  ? _c("CustomerData", {
                                                      attrs: {
                                                        customer:
                                                          message.customer
                                                      }
                                                    })
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.isShowApplicantData(message)
                                                  ? _c("ApplicantData", {
                                                      attrs: {
                                                        "disclosed-data":
                                                          message.disclosedData
                                                      }
                                                    })
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.isShowApplicantAnonymousInfo(
                                                  message
                                                )
                                                  ? _c(
                                                      "ApplicantAnonymousInfo",
                                                      {
                                                        attrs: {
                                                          customer:
                                                            message.customer
                                                        }
                                                      }
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.isApplicantMustSendVita(
                                                  message
                                                ) && message.vitaInfo
                                                  ? _c("SendVita", {
                                                      attrs: {
                                                        conversation:
                                                          message.conversation,
                                                        "vita-info":
                                                          message.vitaInfo
                                                      },
                                                      on: {
                                                        deleteDocument: function(
                                                          $event
                                                        ) {
                                                          _vm.confirmVitaDocumentDeletion = true
                                                        }
                                                      },
                                                      model: {
                                                        value: _vm.sendVitaData,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.sendVitaData = $$v
                                                        },
                                                        expression:
                                                          "sendVitaData"
                                                      }
                                                    })
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.isApplicantSentVita(
                                                  message
                                                ) && message.vitaInfo
                                                  ? _c("ApplicantSentVita", {
                                                      attrs: {
                                                        conversation:
                                                          message.conversation,
                                                        "vita-info":
                                                          message.vitaInfo
                                                      }
                                                    })
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.isShowCustomerPostConnection(
                                                  message
                                                )
                                                  ? _c("CustomerPostConnection")
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.isShowAppointmentResponse(
                                                  message
                                                )
                                                  ? _c("AppointmentResponse")
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.isShowAppointmentSendLink(
                                                  message
                                                )
                                                  ? _c("AppointmentSendLink", {
                                                      on: {
                                                        sendAccessLink: function(
                                                          $event
                                                        ) {
                                                          _vm.sendAccessLink = true
                                                        }
                                                      }
                                                    })
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.isShowPostAppointmentWaiting(
                                                  message
                                                )
                                                  ? _c("PostAppointmentWaiting")
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.isShowCollaborationText(
                                                  message
                                                )
                                                  ? _c("CollaborationText", {
                                                      attrs: {
                                                        message: message
                                                      }
                                                    })
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.isShowCollaborationApplicantDecision(
                                                  message
                                                )
                                                  ? _c(
                                                      "CollaborationApplicantDecision",
                                                      {
                                                        attrs: {
                                                          message: message
                                                        }
                                                      }
                                                    )
                                                  : _vm._e()
                                              ]
                                            })
                                          ],
                                          2
                                        ),
                                        _vm._v(" "),
                                        _vm.latestMessage.employment
                                          ? _c("EmploymentInfo", {
                                              attrs: {
                                                message: _vm.latestMessage,
                                                initiator: _vm.initiator
                                              }
                                            })
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          ]
                        : _c("div", [
                            _vm._v(
                              "\n\t\t\t\t\tDerzeit sind keine Nachrichten vorhanden.\n\t\t\t\t"
                            )
                          ])
                    ]
              ],
              2
            ),
            _vm._v(" "),
            !_vm.loading && _vm.hasMessages
              ? _c("footer", [
                  _vm.isSendOffPossible(_vm.latestMessage) && !_vm.replying
                    ? _c("div", { staticClass: "mb-md-2 mb-2 mb-md-0" }, [
                        _c(
                          "a",
                          {
                            attrs: { href: "#" },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.sendOff.apply(null, arguments)
                              }
                            }
                          },
                          [_vm._v("Verabschieden")]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowAppointmentSendLink(_vm.latestMessage) ||
                  _vm.replyable ||
                  _vm.isApplicantMustSendVita(_vm.latestMessage)
                    ? _c(
                        "div",
                        { staticClass: "flex-grow-1 text-right" },
                        [
                          _vm.isApplicantMustSendVita(_vm.latestMessage)
                            ? _c(
                                "span",
                                { staticClass: "mr-1" },
                                [
                                  _vm.replying
                                    ? _c("Loading", {
                                        attrs: { small: "", "fun-fact": false }
                                      })
                                    : _c(
                                        "a",
                                        {
                                          attrs: { href: "#" },
                                          on: {
                                            click: function($event) {
                                              $event.preventDefault()
                                              return _vm.declineVita.apply(
                                                null,
                                                arguments
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "Ablehnen und nach Termin fragen"
                                          )
                                        ]
                                      )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isShowAppointmentSendLink(_vm.latestMessage)
                            ? _c("Button", {
                                attrs: {
                                  text: "Zugangsdaten schicken",
                                  icon: "checkmark"
                                },
                                on: {
                                  click: function($event) {
                                    _vm.sendAccessLink = true
                                  }
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.replyable && !_vm.replying
                            ? _c("Button", {
                                attrs: {
                                  text: _vm.replyButtonText,
                                  disabled: _vm.replyButtonDisabled,
                                  icon: "checkmark"
                                },
                                on: { click: _vm.reply }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e()
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _vm.sendAccessLink && _vm.latestMessage.appointment
            ? _c("SendAccessLinkPopUp", {
                attrs: { appointment: _vm.latestMessage.appointment },
                on: {
                  sent: _vm.onSentAccessLink,
                  hidden: function($event) {
                    _vm.sendAccessLink = false
                  }
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.confirmVitaDocumentDeletion
            ? _c(
                "ConfirmPopUp",
                {
                  attrs: {
                    title: "Lebenslauf löschen",
                    closable: !_vm.deletingVitaDocument,
                    "confirm-loading": _vm.deletingVitaDocument,
                    "confirm-disabled": _vm.deletingVitaDocument
                  },
                  on: {
                    confirm: _vm.deleteUploadedVita,
                    hidden: function($event) {
                      _vm.confirmVitaDocumentDeletion = false
                    }
                  }
                },
                [
                  _vm._v(
                    "\n\t\tSoll dein Lebenslauf wirklich gelöscht werden?\n\t"
                  )
                ]
              )
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }